var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-color-picker',{attrs:{"predefine":_vm.predefineColors},on:{"change":_vm.confirmColor},model:{value:(_vm.selectedColor),callback:function ($$v) {_vm.selectedColor=$$v},expression:"selectedColor"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }